import { get } from 'lodash';
import { FlowNode } from '../flowState';
import { ZT_API_NAMESPACE } from 'app/beta-editor/constants';

// !!! IMPORTANT !!!
// This function affects the global flows redux state. You
// may need to make the same changes to both the beta-editor
// and classic-editor code. Edit with caution and test thoroughly.
const isNodeTemplate = (node: FlowNode) => get(node, ZT_API_NAMESPACE, false);

export default isNodeTemplate;
